import React, { useState } from "react";
import Helmet from "../components/Helmet";
import Paper from "@mui/material/Paper";
import { TextField, IconButton, Alert } from "@mui/material";
import { Button } from "@mui/material";
import { Link } from "react-router-dom";
import LockResetIcon from "@mui/icons-material/LockReset";
import CloseIcon from "@mui/icons-material/Close";
import Snackbar from "@mui/material/Snackbar";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const Forgotpass = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [snackMessage, setSnackMessage] = useState("Failed to send reset email. Please try again.");

  const onChangeHandler = (e) => {
    setEmail(e.target.value);
    setError("");
  };

  const validate = () => {
    if (!email?.trim()) {
      setError("Email is required.");
      return false;
    }
    if (!EMAIL_REGEX.test(email)) {
      setError("Please enter a valid email.");
      return false;
    }
    return true;
  };

  const handleSubmit = async () => {
    if (!validate()) return;
    setLoading(true);
    try {
      // TODO: Replace with actual API endpoint
      // await axios.post("http://localhost:3000/auth/forgot-password", { email: email.trim() });
      setSnackMessage("Reset password link has been sent to your email.");
      setOpen(true);
      setEmail("");
    } catch (err) {
      const msg = err.response?.data?.message || err.message || "Failed to send reset email. Please try again.";
      setSnackMessage(msg);
      setOpen(true);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpen(false);
  };

  return (
    <Helmet title="Forgot Password">
      <div className="main_frame_login">
        <div className="Top_frame">
          <div className="sub_Frame">
            <header className="login_page_header">
              <LockResetIcon className="login_page_icon" />
              <h1 className="login_page_title">Forgot Password</h1>
              <p className="login_page_subtitle">We will send reset password instructions to your email</p>
            </header>

            <Paper className="main_paper" elevation={0}>
              <div className="frame_button_connect">
                <div className="login_form_fields">
                  <label className="login_label">Email address</label>
                  <TextField
                    className="inputtextcricle"
                    fullWidth
                    type="email"
                    placeholder="e.g. you@example.com"
                    onChange={onChangeHandler}
                    value={email}
                    error={!!error}
                    helperText={error}
                    autoComplete="email"
                    inputProps={{ "aria-label": "Email address" }}
                  />

                  <Button
                    className="button_login"
                    fullWidth
                    onClick={handleSubmit}
                    disabled={loading}
                  >
                    {loading ? "Sending…" : "Continue"}
                  </Button>
                  <Snackbar
                    open={open}
                    autoHideDuration={6000}
                    onClose={handleClose}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                  >
                    <Alert
                      onClose={handleClose}
                      severity={snackMessage.includes("sent") ? "success" : "error"}
                      action={
                        <IconButton size="small" aria-label="close" color="inherit" onClick={handleClose}>
                          <CloseIcon fontSize="small" />
                        </IconButton>
                      }
                    >
                      {snackMessage}
                    </Alert>
                  </Snackbar>
                  <p className="login_signup_text">
                    Go back to{" "}
                    <Link to="/Login" className="login_link">Sign In</Link>
                    {" / "}
                    <Link to="/SignUp" className="login_link">Sign Up</Link>
                  </p>
                </div>
              </div>
            </Paper>
          </div>
        </div>
      </div>
    </Helmet>
  );
};

export default Forgotpass;
